<template>
  <page-container
      :title="titleContent"
  >

    <template v-if="stageSession !== 4" slot="description" class="description">
      <div v-if="stageSession === 0"><i class="el-icon-s-opportunity"></i> Выполните авторизацию через код подтверждения
        или продолжите прием
      </div>
      <div v-if="stageSession === 1"></div>
      <div v-if="stageSession === 2"><i class="el-icon-document"></i> Укажите данные анкеты-опросника</div>
      <div v-if="stageSession === 3"><i class="el-icon-document"></i> Промотр документов пользователя</div>
      <div v-if="stageSession === 4"><i class="el-icon-attract"></i> Введите данные с имеющихся приборов</div>
      <div v-if="stageSession === 5"><i class="el-icon-chat-square"></i> Напишите заключение о визите клиента</div>
    </template>

    <template slot="before">
      <div class="anket-process__right">
        <el-steps direction="vertical" :active="stageSession" finish-status="success" class="navigation">
          <div @click="goItem">
            <el-step description="Подтверждение визита" data-item="10">
              <div slot='title' class="navigation__item">Авторизация</div>
              <div slot="icon" class="step__icon"></div>
            </el-step>
            <el-step data-item="20" description="Данные карточки">
              <div slot='title' class="navigation__item">Карточка клиента</div>
              <div slot="icon" class="step__icon"></div>
            </el-step>
            <el-step data-item="30" description="Просмотр анкет">
              <div slot='title' class="navigation__item">Анкеты</div>
              <div slot="icon" class="step__icon"></div>
            </el-step>
<!--            <el-step data-item="40" description="Просмотр документов">-->
<!--              <div slot='title' class="navigation__item">Документы</div>-->
<!--              <div slot="icon" class="step__icon"></div>-->
<!--            </el-step>-->
            <el-step data-item="40" description="Просмотр приборов">
              <div slot='title' class="navigation__item">Приборы</div>
              <div slot="icon" class="step__icon"></div>
            </el-step>

          </div>
        </el-steps>
      </div>
    </template>

    <router-view/>

  </page-container>
</template>

<script>
import PageContainer from "@/components/elements/PageContainer";
import {mapActions, mapState} from "vuex"

export default {
  name: "session",
  components: {PageContainer},
  data() {
    return {
      stages: {
        10: 'session.create',
        20: 'session.card',
        30: 'session.questionnaire',
        // 40: 'session.documents',
        40: 'session.device',
        60: 'session.close',
      }
    }
  },
  computed: {
    ...mapState("session", {
      session: (state) => state.session,
    }),
    stageSession() {
      for (let key in this.stages)
        if (this.stages[key] === this.$route.name) return (key / 10) - 1

      return 0
    },
    titleContent() {
      if(this.stageSession === 4)  return
      return this.$staticData.session.title[this.$route.name]
    }
  },
  methods: {
    ...mapActions({
      current: "session/CURRENT",
    }),
    goItem(el) {
      let index_page = 0
      if (!this.session) {
        this.$notify.error({
          title: "Нужно открыть сессию",
          message: "Для перехода на другой шаг, пожалуйста откройте сессию",
        });
        return
      }
      for (let i of el.path) {
        if (Array.from(i.classList).includes('el-step')) {
          index_page = (i.dataset.item)
          break
        }
      }
      if (this.$route.name !== this.stages[index_page]) this.$router.push({name: this.stages[index_page]})
    },
    openSession() {
      this.current()
          .then(() => {
            const stage = this.session ? this.session.stage : 10

            if (stage !== 50) this.$router.push({name: this.stages[stage]})
            else {
              this.$notify.error({
                title: "Что-то пошло не так",
                message: "Данная сесия была закрыта",
              });
              this.$router.push("session.create");
            }
          })
          .catch((response) => {
            this.$notify.error({
              title: "Ошибка загрузки 😕",
              message: response.response.data.message,
            });
          })
    }
  }
}
</script>

<style lang="scss" scoped>
.navigation {
  padding: 20px;

  &__item {
    cursor: pointer;
  }
}

.anket-process {
  &__right {
    width: 100%;
  }
}
</style>

